import AccessSection from './components/sections/AccessSection'
import EventSection from './components/sections/EventSection'
import DiscordBotSection from './components/sections/DiscordBotSection'
import LootSection from './components/sections/LootSection'
import NotificationSection from './components/sections/NotificationSection'
import PremiumSection from './components/sections/PremiumSection'
import RecruitmentSection from './components/sections/RecruitmentSection'
import TeamSection from './components/sections/TeamSection'
import RosterSection from './components/sections/RosterSection'
import EntitySettings from 'app/frontend/base/components/EntitySettings'
import Section from 'app/frontend/base/components/Section'
import { useTeam } from 'app/frontend/base/config/context/team'

const TeamSettings = () => {
  const { team, guild } = useTeam()

  return (
    <Section title={`Settings | ${team.name} | ${guild.name}`}>
      <EntitySettings
        entityType='team'
        sections={{
          team: TeamSection,
          events: EventSection,
          loot: LootSection,
          roster: RosterSection,
          recruitment: RecruitmentSection,
          discord_bot: DiscordBotSection,
          access: AccessSection,
          notifications: NotificationSection,
          premium: PremiumSection,
        }}
      />
    </Section>
  )
}

export default TeamSettings
